function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "132.01968mm",
    height: "126.675mm",
    viewBox: "0 63 150 150",
    id: "svg1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76b0e0",
      fillOpacity: 1
    },
    d: "m 60.911737,155.78426 c -0.194764,-2.79591 0.100354,-7.87348 3.594774,-7.46206 3.494421,0.41141 2.782627,2.95895 2.788143,6.71378 0.01288,8.76649 3.943848,14.76006 11.488249,19.43182 7.988273,-0.15258 15.584786,-4.51502 20.632499,-9.45463 6.831638,-1.87349 10.066618,-2.41834 16.221878,-6.49724 1.96896,5.89077 0.95315,11.85311 -1.97848,15.72308 -11.25373,-2.36297 -19.568526,3.95254 -18.31188,16.02474 -11.223697,0.88005 -34.346997,-7.92203 -34.435183,-34.47949 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#76b0e0",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    ry: 12.097212,
    rx: 11.539736,
    cy: 187.39151,
    cx: 109.27831
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7ea866",
      fillOpacity: 1
    },
    d: "m 26.269017,138.1531 c 14.157946,-7.30377 11.130152,-18.51376 5.333479,-23.94657 17.463353,-13.2532 41.894033,-5.85437 50.542763,11.10202 0.642693,1.26004 0.88428,3.97764 -0.09373,4.56518 -0.97801,0.58755 -2.823557,2.79956 -6.1167,-2.46933 -3.000534,-4.80073 -10.216987,-10.87866 -21.367328,-9.76745 -6.95011,6.60103 -8.373891,9.02854 -11.262643,20.09147 -4.651638,5.08043 -6.988105,8.7497 -9.337068,14.68077 -3.561969,-2.10584 -8.461656,-9.1996 -7.698773,-14.25609 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#7ea866",
      fillOpacity: 1,
      strokeWidth: 0.270894
    },
    cx: 22.021671,
    cy: 124.2592,
    rx: 11.983513,
    ry: 11.39222
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d57713",
      fillOpacity: 1
    },
    d: "m 56.417416,188.23535 c 0.676922,-11.8732 -10.803229,-17.31914 -20.347767,-12.76158 -1.985801,-2.28775 -8.281005,-32.224 21.69162,-43.58129 6.585983,-2.49558 8.222267,-0.60847 8.793849,0.87234 0.571582,1.48082 -0.41915,4.01013 -2.946338,4.45984 -9.989956,1.7777 -17.314354,10.83857 -17.104528,18.70127 3.013447,7.33364 7.897846,11.17192 15.301129,15.6698 1.612516,2.88276 5.095837,9.29247 10.718846,13.46204 -2.584824,3.6879 -12.02699,4.62001 -16.106811,3.17758 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#d57713",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    ry: 11.825835,
    rx: 11.825834,
    cy: 187.92163,
    cx: 42.322689
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ddb92f",
      fillOpacity: 1
    },
    d: "m 80.225864,159.1581 c -1.032244,-0.55242 -3.283832,-1.74457 -1.912558,-4.79691 1.371275,-3.05234 4.530821,-1.33035 5.782802,-0.86078 6.6835,2.5067 13.331386,2.97448 23.070852,-3.83159 2.54804,-7.36354 0.25597,-17.65964 -2.7479,-23.18016 1.01052,-7.19658 1.0664,-9.78528 -0.5615,-17.40439 4.86914,-0.65747 12.27343,2.7378 14.64545,6.76522 -5.45899,8.20839 -4.21851,18.35619 9.57994,22.61192 -5.5988,21.21005 -30.746642,29.85359 -47.857086,20.69669 z m 50.833786,-46.07869 c -121.1791702,-40.026065 -121.1791702,-40.026065 0,0 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#ddb92f",
      fillOpacity: 1,
      strokeWidth: 0.25693
    },
    ry: 11.651232,
    rx: 12.264455,
    cy: 124.45255,
    cx: 129.7934
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d85a70",
      fillOpacity: 1
    },
    d: "m 88.446637,143.25695 c -1.839613,-1.66399 -0.816008,-3.23969 1.80557,-6.45647 4.224243,-5.18332 6.337598,-16.43892 1.890309,-23.23447 -5.936679,-3.25205 -11.882367,-5.22272 -22.319158,-3.90288 -4.271389,-2.77854 -10.447211,-4.33573 -16.054543,-4.27451 -0.621186,-2.86071 4.864849,-10.725858 10.442591,-11.83722 7.929885,9.86266 19.122652,7.41315 24.351941,-2.181185 16.192013,10.314485 19.548363,34.624425 5.818985,50.484105 -2.06023,2.3799 -4.096082,3.06663 -5.935695,1.40263 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#d85a70",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    cx: 75.947479,
    cy: 84.918594,
    rx: 11.195125,
    ry: 11.846124
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.251e8bd4ae0beab9f652a0021cf8193b.svg";
export { ForwardRef as ReactComponent };